import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {ObservableBackendService} from './observableBackend.service';
import {City} from '../domain/city';
import {State} from '../domain/state';

@Injectable()
export class CitiesService {

    constructor(private backendService:ObservableBackendService) {
    }

    public getCities(stateId:string):Observable<City[]> {
        return this.backendService.get("cities/" + stateId, null);
    }

    public saveCity(city:City):Observable<City> {
        if (city.id != null) {
            return this.backendService.post("city", city, null);
        } else {
            return this.backendService.put("city", city, null);
        }
    }

    public getCitiesByName(filter:string):Observable<City[]> {
        return this.backendService.get("citiesByName/" + filter, null);
    }

    public deleteCity(id:string):Observable<City> {
        return this.backendService.delete("city/" + id, null, null);
    }

    public getStates():Observable<State[]> {
        return this.backendService.get("states", null);
    }

    public saveState(state:State):Observable<State> {
        if (state.id != null) {
            return this.backendService.post("state", state, null);
        } else {
            return this.backendService.put("state", state, null);
        }
    }

    public deleteState(id:string):Observable<State> {
        return this.backendService.delete("state/" + id, null, null);
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/service/cities.service.ts
 **/